module.exports = __webpack_public_path__ + "static/media/hidden-base.6efebf9c.svg";